module.exports = __webpack_public_path__ + "static/media/best-apps.8f96e20e.png";